<template>
    <Content v-if="variant === 0"
        :trackedCta="{ type: 'upgrade_account_cta', name: 'upgrade_account_promo_card_1' }"
        headerText="Upgrade Today!"
        buttonText="Upgrade Now!"
        actionUrl="/pricing"
        backgroundColor="blue"
        :features="[
            'See who\'s viewing you',
            'Unlock messaging and connect with every college coach',
            'Access game film from top recruiting events',
        ]"
    />

    <Content v-else-if="variant === 1"
        :trackedCta="{ type: 'upgrade_account_cta', name: 'upgrade_account_promo_card_2' }"
        headerText="Upgrade today and see which coaches are viewing your profile!"
        buttonText="Upgrade Now!"
        actionUrl="/pricing"
        backgroundColor="blue"
    />

    <Content v-else-if="variant === 2"
        :trackedCta="{ type: 'upgrade_account_cta', name: 'upgrade_account_promo_card_3' }"
        headerText="Upgrade today and get access to every college coach!"
        buttonText="Upgrade Now!"
        actionUrl="/pricing"
        backgroundColor="blue"
    />
</template>

<script>
    import Content from '../../../../ActivityFeed/PromoCards/Content'

    export default {
        components: { Content },

        props: {
            variant: { type: Number, required: true },
        },

        data() {
            return {
                cta: {
                    type: 'upgrade_account_cta',
                    name: 'prom'
                }
            }
        }
    }
</script>